import { render, staticRenderFns } from "./Invoices.vue?vue&type=template&id=6aee67d1&scoped=true&"
import script from "./Invoices.vue?vue&type=script&lang=js&"
export * from "./Invoices.vue?vue&type=script&lang=js&"
import style0 from "./Invoices.vue?vue&type=style&index=0&id=6aee67d1&prod&lang=scss&"
import style1 from "./Invoices.vue?vue&type=style&index=1&id=6aee67d1&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6aee67d1",
  null
  
)

export default component.exports